export default __webpack_public_path__ + "static/media/proj3_2.3843c23c.jpg";